<div>
    <div class="container my-5">
        
        <!-- Header -->
        <header class="hero-section text-center p-5 mb-5">
            <h1 class="display-4 text-dark fw-light mb-3">Om Fototävling</h1>
            <p class="lead text-muted">Din plattform för professionella fototävlingar</p>
        </header>

        <!-- Huvudinnehåll -->
        <main class="content-card p-5 mb-4">
            
            <!-- Introduktion -->
            <section class="text-center mb-5">
                <h2 class="h3 text-dark fw-light mb-4">En modern lösning för fototävlingar</h2>
                <p class="lead text-muted mx-auto" style="max-width: 700px;">
                    Vår webbaserade plattform förenklar hela processen från tävlingsuppsättning till resultat. 
                    Skapa rättvisa och engagerande fototävlingar med professionella verktyg.
                </p>
            </section>

            <!-- Funktioner -->
            <section class="mb-5">
                <h3 class="h4 text-dark fw-normal text-center mb-5">Så här fungerar det för dig som användare</h3>
                
                <div class="row g-4 justify-content-center">
                    <div class="col-md-5">
                        <div class="text-center p-4">
                            <div class="step-number step-2">1</div>
                            <h4 class="h5 text-dark fw-medium mb-3">Registrera och delta</h4>
                            <p class="text-muted">När en tävling startar får du en inbjudan via e-post. Registrera dig på plattformen och ladda upp dina bilder inom de angivna temana.</p>
                        </div>
                    </div>
                    
                    <div class="col-md-5">
                        <div class="text-center p-4">
                            <div class="step-number step-3">2</div>
                            <h4 class="h5 text-dark fw-medium mb-3">Rösta på bilder</h4>
                            <p class="text-muted">Under röstningsperioden bedömer du andra deltagares bilder. Systemet säkerställer att du aldrig kan se eller rösta på dina egna bidrag.</p>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Röstningstyper -->
            <section class="mb-5">
                <h3 class="h4 text-dark fw-normal text-center mb-5">Två sätt att rösta</h3>
                
                <div class="row g-4">
                    <div class="col-lg-6">
                        <div class="border rounded p-4 h-100">
                            <div class="text-center">
                                <div class="voting-icon">🏠</div>
                                <h4 class="h5 text-dark fw-medium mb-3">Intern röstning</h4>
                                <p class="text-muted mb-4">Samma fotoklubb som tävlar röstar på varandras bilder.</p>
                                <ul class="list-unstyled text-start text-muted">
                                    <li class="mb-2">• Främjar klubbgemenskap</li>
                                    <li class="mb-2">• Automatiskt skydd mot självröstning</li>
                                    <li>• Utvecklar bedömningsförmågan</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="border rounded p-4 h-100">
                            <div class="text-center">
                                <div class="voting-icon">🌍</div>
                                <h4 class="h5 text-dark fw-medium mb-3">Extern röstning</h4>
                                <p class="text-muted mb-4">En annan fotoklubb eller externa experter bedömer bilderna.</p>
                                <ul class="list-unstyled text-start text-muted">
                                    <li class="mb-2">• Objektiv bedömning</li>
                                    <li class="mb-2">• Neutrala röstare</li>
                                    <li>• Inter-klubb tävlingar</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Fördelar -->
            <section>
                <h3 class="h4 text-dark fw-normal text-center mb-5">Varför välja vår plattform?</h3>
                
                <div class="bg-light p-4 rounded border-left-primary">
                    <div class="row g-3">
                        <div class="col-md-6">
                            <div class="d-flex align-items-start mb-3">
                                <span class="feature-check">✓</span>
                                <div>
                                    <strong class="text-dark d-block">Automatiserad rättvisa</strong>
                                    <small class="text-muted">Inbyggt skydd mot partiskhet</small>
                                </div>
                            </div>
                        </div>
                        
                        <div class="col-md-6">
                            <div class="d-flex align-items-start mb-3">
                                <span class="feature-check">✓</span>
                                <div>
                                    <strong class="text-dark d-block">Användarvänligt</strong>
                                    <small class="text-muted">Intuitiv för alla åldrar</small>
                                </div>
                            </div>
                        </div>
                        
                        <div class="col-md-6">
                            <div class="d-flex align-items-start mb-3">
                                <span class="feature-check">✓</span>
                                <div>
                                    <strong class="text-dark d-block">Flexibelt system</strong>
                                    <small class="text-muted">Anpassas efter dina behov</small>
                                </div>
                            </div>
                        </div>
                        
                        <div class="col-md-6">
                            <div class="d-flex align-items-start">
                                <span class="feature-check">✓</span>
                                <div>
                                    <strong class="text-dark d-block">Transparent process</strong>
                                    <small class="text-muted">Tydligt från start till mål</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </main>

        <!-- Footer -->
        <footer class="content-card text-center p-5">
            <h3 class="h4 text-dark fw-normal mb-3">Redo att skapa din nästa fototävling?</h3>
            <p class="text-muted mb-0 mx-auto" style="max-width: 600px;">
                Vår plattform gör det enkelt att organisera professionella fototävlingar som engagerar och inspirerar. 
                Låt kreativiteten flöda och gemenskapen växa!
            </p>
        </footer>

    </div>

    <script src="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/js/bootstrap.bundle.min.js"></script>
</div>




















